module.exports = __webpack_public_path__ + "assets/08a47ab962cd72f9bf8dc3a54833fa39.png";